import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpErrorResponse } from "@angular/common/http";
import { catchError, tap } from "rxjs/operators";
import { throwError } from "rxjs";
import { ErrorService } from '../../error/error.service';
import { CloudNameStorageService } from '../../cloud/cloud-name-storage.service';

@Injectable({
  providedIn: "root",
})
export class CloudMaintenanceHttpInterceptorService implements HttpInterceptor {
  get maintenance() {
    return this.appErrorService.cloudMaintenance;
  }

  set maintenance(v) {
    this.appErrorService.cloudMaintenance = v;
  }

  constructor(
    private appErrorService: ErrorService,
    private cloudNameStorageService: CloudNameStorageService
  ) {}

  intercept(req, next) {
    return next.handle(req).pipe(
      catchError((err) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 503) {
            this.maintenance = this.getCloudMaintenanceMessage();
          }
        }
        return throwError(err);
      })
    );
  }

  loadCloudName() {
    return this.cloudNameStorageService.loadCloudName();
  }

  getCloudMaintenanceMessage() {
    const cloudName = this.loadCloudName();
    if (cloudName) {
      return `${cloudName} is in maintenance`;
    } else {
      return `The cloud is under maintenance`;
    }
  }
}
